import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "container"
  ]

  static classes = [
    "container"
  ]

  connect() {
    if (this.hasContainerClass) {
      this.containerTarget.classList.add(this.containerClass)
    }

    this.hideStickybar()

    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.setStickybarVisible(!entry.isIntersecting)
      })
    }, {
      threshold: 0.1
    })
    this._observer.observe(this.element)
  }

  disconnect() {
    if (this._observer) {
      this._observer.disconnect()
      this._observer = null
    }
  }

  setStickybarVisible(visible) {
    visible ? this.showStickybar() : this.hideStickybar()
  }

  showStickybar() {
    this.containerTarget.style.display = "inherit"
  }

  hideStickybar() {
    this.containerTarget.style.display = "none"
  }
}
